import { useEffect, useState } from "react";
import { IconDown, IconUp } from "./icons/icons";
import {
  ContainerSwicher,
  SwitcherContainer,
  SwitcherContainerOption,
  SwitcherList,
  SwitcherOptionItemButton,
  SwitcherValueText,
  TextValueLangs,
} from "./Swicher.styled";
import { useLanguageContext } from "../../../../Components/Languages/Langs/LanguageContext";
import { ListLangs } from "./ListLang";

export const Swicher = ({ value, setValue }) => {
  const { onClickLanguageChange } = useLanguageContext();

  const [language, setLanguage] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const selectedLanguagePage = "current-lang-page";
  const languageOptionValue = Object.entries(ListLangs());

  const changeLanguage = (lang) => {
    onClickLanguageChange(lang);
    localStorage.setItem(selectedLanguagePage, JSON.stringify(lang));
  };

  const openSelect = () => {
    setLanguage(true);
  };

  const hideSelect = () => {
    setLanguage(false);
  };

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        !event.target.closest(".switcherContainer") &&
        !event.target.closest(".switcherOptions")
      ) {
        setIsOpen(false);
      }
    };

    const selectedLanguage = JSON.parse(
      localStorage.getItem(selectedLanguagePage)
    );
    setValue(selectedLanguage);

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [language, setValue, isOpen]);

  return (
    <ContainerSwicher>
      <SwitcherContainer className="switcherContainer" onClick={toggleDropdown}>
        <TextValueLangs>{ListLangs()[value] || "English"}</TextValueLangs>
        <SwitcherValueText onClick={language ? hideSelect : openSelect}>
          {isOpen ? <IconUp /> : <IconDown />}
        </SwitcherValueText>

        {isOpen && (
          <SwitcherContainerOption>
            <SwitcherList>
              {languageOptionValue.map(([code, label]) => (
                <li key={code}>
                  <SwitcherOptionItemButton
                    onClick={(e) => {
                      changeLanguage(code);
                      toggleDropdown(e);
                    }}
                  >
                    {label}
                  </SwitcherOptionItemButton>
                </li>
              ))}
            </SwitcherList>
          </SwitcherContainerOption>
        )}
      </SwitcherContainer>
    </ContainerSwicher>
  );
};
